const axios = require("axios");
/* NodeJS */
const url = process.env.REACT_APP_BASE_URL;

module.exports = {
  getProperty: (propertyUid) =>
    axios({
      method: "POST",
      url: `${url}/access-token?property_uid=${propertyUid}`,
    }),
};
